// import { yupResolver } from '@hookform/resolvers/yup'
// import { Textarea } from '@nextui-org/react'
// import { Auth } from 'aws-amplify'
import { NextSeo } from 'next-seo'

// import AuthBg from '@/assets/illustrations/auth.svg'
// import bottomImg from '@/assets/illustrations/home.svg'
// import Button, { ButtonVariant } from '@/components/button'
// import Input from '@/components/input'
// import Link from '@/components/link'
// import handleApiError from '@/utils/handle-api-error'
// import ContactUs from '@/pages/contactUs'

const privacypolicy = () => {
  return (
    <div className='flex h-[100%] min-h-full flex-wrap items-center bg-theme-turquoise px-5'>
      <NextSeo title='Privacy Policy' />
      <div className='h-bg-intr custom-page mt-[50px] flex-[0_0_100%]'>
        <div className='relative'>
          <ul className='custom-heading list-[circle]'>
            <li>
              <h1 className='font-normal uppercase'>privacy policy</h1>
            </li>
          </ul>
          <div className='policy-container'>
            <div className='pt-4 md:pt-14'>
              <div className='font-medium'>
                <p className=' pb-4 md:pb-14'>
                  Thank you for visiting the Thrive Cafe website and reviewing
                  our privacy policy.
                </p>
                <p className='pb-4 md:pb-14'>
                  BY USING OUR SERVICES OR BY OTHERWISE GIVING US YOUR
                  INFORMATION, YOU AGREE TO THE TERMS OF THIS PRIVACY POLICY.
                </p>
              </div>
              <div className=' pb-4 md:pb-14'>
                <p>
                  We collect no personal information about you unless you
                  affirmatively choose to provide that information to us. Such
                  personal information collected during registration for certain
                  services we offer on our website to students and participants.
                  We do not give, share, sell, or transfer any personal
                  information to any unrelated third party.
                </p>
                <p className='pb-4 md:pb-14'>
                  No system is 100% secure so we do not claim to comply exactly
                  per the General Data Protection Regulation (GDPR) (EU)
                  2016/679, but we take serious measures to protect your data as
                  much as possible.
                </p>
                <p className=' pb-4 md:pb-14'>
                  Thrive Cafe is committed to safeguarding its users' privacy.
                  We request all our users to read the following 'privacy
                  policy' to understand how the personal information will be
                  collected, used and maintained, as you make use of our
                  services.
                </p>
              </div>
            </div>
            <div className='flex flex-wrap'>
              <div>
                <div className=' pb-4 md:pb-14'>
                  <h3 className=' pb-4 font-medium md:pb-14'>
                    Non-Personal information gathered automatically
                  </h3>
                  <p>
                    If you do nothing during your visit but browse through the
                    website, read pages, or download information, our website's
                    operating system will automatically record some general
                    information about your visit. During your visit our web
                    operating system will record:
                  </p>
                  <ul className='custom-margin ml-5 list-[circle] md:ml-8'>
                    <li>
                      The Internet domain or internet service provider for your
                      internet service, Browser type, type of operating system
                      platform, date / time stamp, referring/exit pages address
                      of the previous website that you were visiting, if you
                      linked to us from another website, domain name and
                      country/state.
                    </li>
                    <li>
                      IP address to help diagnose problems with servers that
                      host and administer our website.
                    </li>
                    <li>
                      Our website might contain links to third party websites.
                      We do not have control and are not responsible for, the
                      content, privacy policies or reliability of such sites.
                    </li>
                    <li>
                      We use this information for statistical analysis, to help
                      us make our site more useful to visitors. This tracking
                      system does not record information about individuals.
                    </li>
                  </ul>
                </div>
                <div className=' pb-4 md:pb-14'>
                  <h3 className=' pb-4 font-medium md:pb-14'>
                    Updating your personal information and privacy preferences
                  </h3>
                  <p>
                    You have the right to access, correct and delete
                    inaccuracies in your personal information and privacy
                    preferences at any time. With respect to Registration
                    Information (as defined in the section entitled "Protection
                    of your personal information"), this may be accomplished by
                    logging in to your account on the relevant Thrive Cafe
                    website, where you can typically view and make changes to
                    your personal information. You may also access and correct
                    your personal information and privacy preferences (such as
                    whether you wish to receive promotional communications) by
                    writing to Thrive Cafe.
                  </p>
                </div>
                <div className=' pb-4 md:pb-14'>
                  <h3 className=' pb-4 font-medium md:pb-14'>
                    Collection of personal information
                  </h3>
                  <p className=' pb-4 md:pb-14'>
                    As a visitor to this site, you can engage in many activities
                    without providing any personal information. In connection
                    with other activities, such as utilizing online or hosted
                    Programs and Services, Thrive Cafe may ask you to provide
                    certain information about yourself by filling out and
                    submitting a form. It is optional for you to engage in these
                    activities. If you elect to engage in these activities,
                    however, Thrive Cafe may ask that you provide certain
                    personal information, sensitive personal data or information
                    (as well as certain non-personal information that may be
                    tied to personal information), including but not limited to
                    your first and last name, mailing address (including ZIP
                    code), country of residence, e-mail address, employer, job
                    title and department, and telephone and mobile numbers, PAN
                    card (if applicable) and/or any other document to comply
                    with the applicable rules and regulations as per the
                    government mandate. Depending upon the activity you intend
                    to use on some Services and Programs, some of the
                    information that we ask you to provide is identified as
                    mandatory and some as voluntary. If you do not provide the
                    mandatory data with respect to a particular activity, you
                    will not be able to engage in that activity. Similarly, if
                    you wish to delete your information that is mandatory, you
                    will no longer be able to engage in that particular
                    activity.
                  </p>
                  <p>
                    When you use the site and the Services, Thrive Café may also
                    collect certain information about your computer to
                    facilitate, evaluate and verify your use of the Site and the
                    Services. For example, we may log environmental variables,
                    such as browser type, operating system, CPU speed, referring
                    or exit webpages, click patterns, Session ID (a unique
                    identifier assigned to the browser in connection to the
                    Site), and the Internet Protocol (IP) address of your
                    computer. Thrive Cafe also uses such information to measure
                    traffic patterns on the Site and usage of the Programs and
                    Services. We do not match such information with personal
                    information held about you by Thrive Cafe unless we have
                    your consent, except as otherwise described in this Privacy
                    Policy.
                  </p>
                  <p>
                    Subject to what is permitted by applicable law, Thrive Cafe
                    may collect and use your personal information and/or
                    sensitive personal information:
                  </p>
                  <ul className='custom-margin ml-5 list-[circle]'>
                    <li>for Internal record keeping;</li>
                    <li>
                      to send periodical promotional emails about new products,
                      special offers or other information which we think you may
                      find interesting using the email address which you have
                      provided;
                    </li>
                    <li>
                      to contact you for survey, market research purposes and/or
                      to customize the website according to your interests;
                    </li>
                    <li>
                      to agents, contractors, service providers, insurers and
                      external advisers engaged by Thrive Cafe from time to time
                      to carry out, provide services or advise on the functions
                      and activities;
                    </li>
                    <li>
                      to other related body corporate /affiliates of Thrive
                      Cafe;
                    </li>
                    <li>
                      to regulatory bodies, government agencies, law enforcement
                      bodies and courts;
                    </li>
                    <li>
                      to any person or organization who Thrive Cafe deems
                      necessary for carrying out the instructions you give to
                      Thrive Cafe; and
                    </li>
                    <li>
                      any prospective transferee in a scheme of arrangement,
                      amalgamation, merger or sale of shares or sale of business
                      relating to the whole or part of Thrive Cafe.
                    </li>
                  </ul>
                </div>
              </div>
              <div className=' pb-4 md:pb-14'>
                <h3 className=' pb-4 font-medium md:pb-14'>Cookies</h3>
                <p>
                  Certain pages on the Thrive Cafe website, use "cookies", which
                  will help you use our websites interactively. A cookie is a
                  small file that a website transfers to your computer's hard
                  disk, usually to keep track of you while you are connected to
                  that site. The cookies on Thrive Cafe web pages do not collect
                  information about you, but only about your browser "session."
                  The cookie makes it easier for you to use the dynamic features
                  of these web pages, without having to provide the same
                  information again as you move from one page to another. To
                  protect your privacy, be sure to close your browser completely
                  after you have finished browsing/ transacting on a website
                  that uses cookies. If you are concerned about the potential
                  use of information gathered from your computer by cookies, you
                  can set your browser to prompt you before it accepts a cookie.
                  Most Internet browsers have settings that let you identify
                  and/or reject cookies.
                </p>
              </div>
              <div className=' pb-4 md:pb-14'>
                <h3 className=' pb-4 font-medium md:pb-14'>
                  Information from e-mails
                </h3>
                <p>
                  If you decide to send us an electronic mail message (e-mail),
                  the message will usually contain return e-mail address. If you
                  include, personally-identifiable information in your e-mail,
                  because you want us to address specific to your situation, we
                  may use that information in responding to your request. E-mail
                  is not necessarily secure against interception. Please send us
                  only information to help us process your request for the
                  specified service.
                </p>
              </div>
              <div className=' pb-4 md:pb-14'>
                <h3 className=' pb-4 font-medium md:pb-14'>
                  Information Collected from Interactive Forms
                </h3>
                <p className='pb-4 md:pb-14'>
                  On some of our web pages, we offer interactive forms that let
                  you voluntarily consent to submit personal information (such
                  as your e-mail, address, name or organisation). This occurs
                  when you are registering for online counselling, various test,
                  quizzes, seminars, workshops or training sessions offered by
                  Thrive Cafe, downloading admission forms from Thrive Cafe. In
                  those cases, all submitted information is used only for the
                  purposes for which it is intended and is not made available to
                  any third party, other than specifically permitted under this
                  Privacy Policy.
                </p>
                <p>
                  If required, we may also ask you to provide information of
                  others such as when reporting suspected piracy. In this
                  instance, we will ask for the person's or company's name and
                  contact information so that we may investigate. Personal
                  information supplied in these instances will only be used for
                  the purpose being submitted.
                </p>
                <p>
                  Thrive Cafe also hires other companies to place our banner ads
                  on other websites. Such companies perform tracking and
                  reporting activities on ads served and user reaction
                  ("third-party advertisement servers"). They do not collect any
                  information other than IP addresses and behaviours associated
                  with those IP addresses on our behalf, and we do not give any
                  personal information to them. Third-party advertisement
                  servers are subject to their own privacy policies. Thrive Cafe
                  may also allow other companies to display advertisements on
                  certain pages of the site or within the Programs and Services.
                  If you click on these advertisements these companies may place
                  a persistent cookie on your computer which may allow them to
                  display further advertisements to you. It is our policy to
                  require these companies to provide accessible methods for you
                  to disable these cookies.
                </p>
              </div>
              <div className=' pb-4 md:pb-14'>
                <h3 className=' pb-4 font-medium md:pb-14'>
                  Links to other sites
                </h3>
                <p>
                  Our website may contain links to other websites of interest.
                  However, once you have used these links to leave our site, you
                  should note that we do not have any control over that other
                  website. Therefore, we cannot be responsible for the
                  protection and privacy of any information which you provide
                  whilst visiting such sites and such sites are not governed by
                  this privacy statement.
                </p>
              </div>
              <div className=' pb-4 md:pb-14'>
                <h3 className=' pb-4 font-medium md:pb-14'>Security</h3>
                <p>
                  We are committed to ensuring that your information is secure
                  but remember that no method of transmission over the internet
                  is 100% secure. In order to prevent unauthorized access or
                  disclosure, we have put in place suitable physical, electronic
                  and managerial procedures to safeguard and secure the
                  information we collect online.
                </p>
              </div>
              <div className=' pb-4 md:pb-14'>
                <h3 className='pb-4 font-medium md:pb-14'>
                  Changes to this Privacy Policy
                </h3>
                <p>
                  This privacy policy is subject to changes from time to time,
                  please check periodically.
                </p>
              </div>
              <div className=' pb-4 md:pb-14'>
                <h3 className=' pb-4 font-medium md:pb-14'>Effective Date</h3>
                <p>
                  This Privacy Policy is effective from 1st June 2022 and it
                  supersedes all existing polices on the subject matter.
                </p>
              </div>
              <div className=' pb-4 md:pb-14'>
                <h3 className=' pb-4 font-medium md:pb-14'>Applicability</h3>
                <p className=''>
                  This Policy applies to all Personal Data collected
                  electronically by Thrive Cafe.
                </p>
                <p className='pb-4 md:pb-14'>
                  For any questions, please reach out to our Grievance Officer
                  for Data Privacy regulations compliance
                </p>
                <ul className='font-medium'>
                  <li>Name: Abhimanyu Hingorani</li>
                  <li>E-mail ID: Abhimanyu@thrivecafe.in</li>
                  <li>
                    Address: Thrive Cafe, 76/6 1C, HVS Homes 5, 15th Cross
                    Malleswaram, Bangalore-560055.
                  </li>
                </ul>
              </div>
              <div className=' pb-4 md:pb-14'>
                <h3 className=' pb-4 font-medium md:pb-14'>
                  Deleting Personal Information
                </h3>
                <p>
                  If you would like to delete your information from our servers,
                  write to info@thrivecafe.in
                </p>
              </div>
              <div className='md:pb-14> pb-4 '>
                <h3 className=' pb-4 font-medium md:pb-14'>
                  Privacy Policy Questions?
                </h3>
                <p>
                  If you have any questions regarding Thrive Cafe's Privacy
                  Policy, please write to info@thrivecafe.in
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>
        {`
          h3.contact-detail {
            margin-bottom: 20px;
          }
          .custom-page {
            padding-inline: calc(
              35px + (540 - 35) * (100vw - 375px) / (1920 - 375)
            );
            margin-bottom: calc(
              110.61pt + (331.84 - 110.61) * (100vw - 375px) / (1920 - 375)
            );
          }
          .custom-heading {
            font-size: calc(12pt + (48 - 12) * (100vw - 375px) / (1920 - 375));
            margin-top: calc(
              50px + (155 - 50) * (100vw - 375px) / (1920 - 375)
            );
            margin-left: calc(
              18px + (38 - 18) * (100vw - 375px) / (1920 - 375)
            );
          }
          @media (max-width: 767px) {
            .custom-heading {
              margin-left: 14px;
            }
            .custom-margin {
              margin-left: 11px;
            }
          }
          .policy-container {
            font-weight: 300;
            font-size: calc(9pt + (27 - 9) * (100vw - 281pt) / (1920 - 375));
            line-height: calc(
              12pt + (25 - 12) * (100vw - 281pt) / (1920 - 375)
            );
            margin-bottom: calc(
              8pt + (25 - 12) * (100vw - 281pt) / (1920 - 375)
            );
          }
        `}
      </style>
    </div>
  )
}
export default privacypolicy
